import React from 'react';
import { Box } from '@mui/material';
import AskRecordLauncher from '../../AskRecord/AskRecordLauncher';
import StructuredTrackingLauncher from '../shared/StructuredTrackingLauncher';

const MobileToolsPanel = React.forwardRef(({
  child,
  logCount,
  onOpenAskSource,
  onOpenCareKnowledge,
  onOpenInsights,
  onOpenTherapyPrep,
  onOpenCustomPrepare,
  onOpenIepJourney,
  onOpenMood,
  onOpenCustomNote,
  onImportLogs,
}, ref) => (
  <Box ref={ref} sx={{ mb: 1.05, scrollMarginTop: 12 }}>
    <StructuredTrackingLauncher
      child={child}
      variant="section"
      askLauncher={(
        <AskRecordLauncher
          child={child}
          logCount={logCount}
          onOpenSource={onOpenAskSource}
          variant="toolsHero"
        />
      )}
      onOpenCareKnowledge={onOpenCareKnowledge}
      onOpenInsights={onOpenInsights}
      onOpenTherapyPrep={onOpenTherapyPrep}
      onOpenCustomPrepare={onOpenCustomPrepare}
      onOpenIepJourney={onOpenIepJourney}
      onOpenMood={onOpenMood}
      onOpenCustomNote={onOpenCustomNote}
      onImportLogs={onImportLogs}
    />
  </Box>
));

MobileToolsPanel.displayName = 'MobileToolsPanel';

export default MobileToolsPanel;
